import React from 'react';
import { Bell, MessageCircle } from 'lucide-react';

const IconWrapper = ({ children, count }: any) => (
  <div className="relative w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 cursor-pointer">
    {children}
    {count && (
      <span className="absolute -top-1 -right-1 bg-primary text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
        {count}
      </span>
    )}
  </div>
);

const HeaderIcons: React.FC = () => {
  return (
    <div className="flex items-center gap-4">
      <IconWrapper count={18}>
        <MessageCircle size={18} className="text-gray-600" />
      </IconWrapper>

      <IconWrapper count={52}>
        <Bell size={18} className="text-gray-600" />
      </IconWrapper>
    </div>
  );
};

export default HeaderIcons;